import { useTranslation } from 'react-i18next';

import { Button } from '@arco-design/web-react';
import { IconPlus } from '@arco-design/web-react/icon';

import { IconFont } from '@/components';

import styles from './index.module.less';
import type { ResourceConfigAddCardProps } from './types';

/** 资源配置空态卡片：左侧图标+名称，右侧添加按钮（与 summaryCard 同风格） */
export function ResourceConfigAddCard({ resourceCode, icon, title, hasError, onAdd }: ResourceConfigAddCardProps) {
  const { t } = useTranslation();

  return (
    <div
      className={[styles.summaryCard, styles.addCard, hasError ? styles.summaryCardError : ''].filter(Boolean).join(' ')}
      data-resource-code={resourceCode}
      onClick={onAdd}
    >
      <div className={styles.summaryMain}>
        <div className={styles.addCardLabel}>
          <span className={styles.addCardIcon}>
            <IconFont name={icon} style={{ fontSize: 36 }} />
          </span>
          <span className={styles.addCardTitle}>{title}</span>
        </div>
        <div className={styles.summaryActions}>
          <Button
            type={hasError ? undefined : 'dashed'}
            className={hasError ? undefined : styles.addButton}
            status={hasError ? 'danger' : undefined}
            icon={<IconPlus />}
            onClick={(event) => {
              event.stopPropagation();
              onAdd();
            }}
          >
            {t('common:add')}
          </Button>
        </div>
      </div>
    </div>
  );
}
